module.exports = __webpack_public_path__ + "static/yachtsafe-hero@2x-min-cd552eb36ef792c42f880b16dc1b7050.png";